import React from 'react'
import { MessageBox } from 'mailup-web-components'
import { useRecoilValue } from 'recoil'
import { pageErrorState } from 'Pages/TemplateEdit/recoil/state/page'

const ErrorFeedback = () => {
  const { error, severity } = useRecoilValue(pageErrorState)

  return (
    <>
      {error && (
        <MessageBox variant={severity}>
          <span>{error}</span>
        </MessageBox>
      )}
    </>
  )
}

export default ErrorFeedback
